import { redirect } from '@tanstack/react-router';
import { api, ApiError } from './api';

/**
 * beforeLoad-guard: probes an API endpoint and redirects to /login on 401
 * or back to / on 403. Used on every protected route so the client never
 * renders a page it would immediately fail to hydrate.
 *
 * F-506 (2026-05-06): per HEAD geprobt statt GET. Fastify 5 registriert HEAD
 * automatisch für jede GET-Route (`exposeHeadRoutes` default true) und der
 * preHandler-Permission-Check liefert weiterhin den 401/403/200, ohne dass
 * Listen-Bodies durchs Wire gehen. DB-Read passiert beim Auto-HEAD trotzdem
 * — die saubere Lösung wäre ein /me?permissions[]-basiertes RBAC-Mapping
 * (Variante B), übersteigt aber den 2 h-Effort-Rahmen von F-506.
 */
export async function requireAccess(probePath: string): Promise<void> {
  try {
    await api(probePath, { method: 'HEAD' });
  } catch (err) {
    if (err instanceof ApiError && err.status === 401) {
      throw redirect({ to: '/login' });
    }
    if (err instanceof ApiError && err.status === 403) {
      throw redirect({ to: '/' });
    }
    throw err;
  }
}
